var env = "";
var staticEnv = "";
if (typeof window !== "undefined") {
  if (location.host.includes(".dev.")) {
    // env = "dev.";
    // staticEnv = "dev.";
    env = "test.";
    staticEnv = "test.";
  } else if (location.host.includes(".test.")) {
    env = "test.";
    staticEnv = "test.";
  } else {
    env = "";
    staticEnv = "";
  }
}
export var apiVersion = "6.4";
export var host = {
  www: "https://www.".concat(env, "8891.com.tw"),
  auto: "https://auto.".concat(env, "8891.com.tw"),
  c: "https://c.".concat(env, "8891.com.tw"),
  m: "https://m.".concat(env, "8891.com.tw"),
  image: "https://img.".concat(staticEnv, "8891.com.tw/next"),
  upload: "https://upload.8891.com.tw",
  dc: env === "" ? "https://dc.8891.tw/api" : "https://dc.test.8891.com.tw/api",
  im: "https://im.".concat(env, "8891.com.tw"),
  imws: "wss://im.".concat(env, "8891.com.tw").concat(env === "" ? ":1218" : ""),
  used: "https://usedcar.".concat(env, "8891.com.tw"),
  ad: "https://admanager.".concat(env, "8891.com.tw"),
  admin: "https://admin.".concat(env, "8891.com.tw")
};
var c = host.c,
  www = host.www,
  dc = host.dc,
  upload = host.upload,
  used = host.used,
  admin = host.admin;
export var path = {
  newCarApiV1: "".concat(c, "/api/v1"),
  newCarApiV2: "".concat(c, "/api/v2"),
  newCarApiV3: "".concat(c, "/api/v3"),
  newCarApiV4: "".concat(c, "/api/v4"),
  newCarApiV5: "".concat(c, "/api/v5"),
  usedCarApi: "".concat(www, "/oapi"),
  usedCarApiV3: "".concat(www, "/api/v3"),
  usedCarApiV4: "".concat(www, "/api/v4"),
  usedCarApiV5: "".concat(www, "/api/v5"),
  uploadApi: "".concat(upload, "/v2/upload"),
  collectApi: "".concat(dc, "behavioral_push"),
  pushCollectApi: "".concat(dc, "/pushDataCollection"),
  provision: "".concat(www, "/help-sev.html"),
  disclaimer: "".concat(www, "/help-laimer.html"),
  privacy: "".concat(www, "/help-pris.html"),
  brandList: "".concat(c, "/photoModel-brandList.html"),
  modelList: "".concat(c, "/photoModel-info.html"),
  usedApi: "".concat(used, "/api"),
  env: env,
  onlineService: "".concat(www, "/help-OnlineServer.html"),
  adminApi: "".concat(admin, "/admin.php")
};